import React, { useState } from "react";
import { Table, Badge } from "antd";
import { AUDIT_STATUS, AUDIT_PROCESS } from "./util";
import { useHistory } from "react-router-dom";

const Content = (props) => {
  const {
    dataSource,
    page,
    onTableChange = () => {},
    onShowSizeChange = () => {},
  } = props;

  const history = useHistory();

  const handleRedirect = (current, type) => {
    if (type === "detail") {
      history.push(`/page/operating/evaluation/${current.tryRecordId}`);
      window.localStorage.setItem(
        "tryGoodsEvaluateId",
        current.tryGoodsEvaluateId
      );
    } else {
      // history.push(`/page/business/split/record/${current.companyId}`);
    }
  };

  const columns = [
    {
      title: "提交时间",
      dataIndex: "submitTime",
      key: "submitTime",
    },
    {
      title: "用户昵称",
      dataIndex: "nickName",
      key: "nickName",
      // render: (text) => Audit_Staus_REVERSE[text],
    },
    {
      title: "试用商品",
      dataIndex: "materialsName",
      key: "materialsName",
    },
    {
      title: "品牌商",
      dataIndex: "brandCompanyName",
      key: "brandCompanyName",
    },
    {
      title: "点位名称",
      dataIndex: "tryPointName",
      key: "tryPointName",
    },
    {
      title: "使用报告",
      dataIndex: "detail",
      key: "detail",
      render: (text, record) => (
        <a href="#" onClick={() => handleRedirect(record, "detail")}>
          查看详情
        </a>
      ),
    },
    {
      title: "审核状态",
      dataIndex: "state",
      key: "state",
      render: (text) => (
        <Badge status={AUDIT_PROCESS[text]} text={AUDIT_STATUS[text]} />
      ),
    },
    {
      title: "发布时间",
      dataIndex: "examineTime",
      key: "examineTime",
    },
  ];

  return (
    <div className="content">
      <Table
        rowSelection={null}
        dataSource={dataSource}
        rowKey="companyId"
        columns={columns}
        pagination={{
          showTotal: () => `共${page.total}条`,
          total: page.total,
          current: page.pageNum,
          pageSize: page.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "30", "40"],
          onChange: onTableChange,
          onShowSizeChange: onShowSizeChange,
        }}
      />
    </div>
  );
};

export default Content;
